import { apiFunctionsEnum } from 'constants/api.constants';
import ApiService from './api.service';
import { setSearchResults, setError } from 'state/reducers/dashboard.reducer';
import { setErrorMessage } from 'utils/index';

export function getSearchMatches(data: any) {
	const { searchWord, searchType } = data;
	return async (dispatch: any) => {
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_ACCOUNTS_BY_SEARCH, { searchWord, searchType })
			.then((response: any) => {
				dispatch(setSearchResults(!response.data.searchResult.length ? null : response.data.searchResult));
			})
			.catch((error: any) => {
				dispatch(setSearchResults(null));
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			});
	};
}
